// extracted by mini-css-extract-plugin
module.exports = {"content":"Dailymotion_content__3lRvd","videoNotFound":"Dailymotion_videoNotFound__MPmxf"};